import TransactionsFilters from './TransactionFilters.container';

export default TransactionsFilters;



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/Transactions/TransactionFilters/index.js